import { backendConfig } from 'src/config';

export const BASE_URL = '/';

export const SHORT_URL_BASE = backendConfig.shortUrlBase ?? 'https://mloop.in';
